<div class="fdd-shell">
  <app-field-details-timeline-section
    [timelineDatesLoading]="timelineDatesLoading()"
    [timelineDates]="timelineDates()"
    [selectedTimelineDate]="selectedTimelineDate()"
    [anomaliesByDay]="emptyAnomalies"
    [titleKey]="'FIELD_DETAILS_V2.ATM_TIMELINE_TITLE'"
    [emptyKey]="'FIELD_DETAILS_V2.ATM_TIMELINE_EMPTY'"
    [showLegend]="false"
    (calendarOpen)="openCalendarDialog()"
    (datePick)="onTimelinePick($event)"
  />

  <section class="fdd-card fdd-atm-list-card">
    <div class="fdd-atm-head">
      <h3 class="fdd-atm-title">{{ 'Agrotechnical measures' | translate }}</h3>
      @if (showAdd && hasSeason()) {
        <app-primary-button
          [title]="'Добавить'"
          icon="pi pi-plus"
          size="p-button-sm"
          (action)="openEditModal()"
        ></app-primary-button>
      }
    </div>
    @if (loadFailed()) {
      <div class="fdd-empty muted">{{ 'FIELD_DETAILS_V2.ATM_LOAD_ERROR' | translate }}</div>
    } @else if (!hasSeason() && !timelineDatesLoading()) {
      <div class="fdd-empty muted">{{ 'No data found' | translate }}</div>
    } @else {
      <div class="fdd-atm-table-wrap">
        <app-data-table
          [columns]="tableColumns"
          [data]="dayRows()"
          [config]="tableConfig"
          [totalRecords]="dayRows().length"
          [loading]="timelineDatesLoading()"
        ></app-data-table>
      </div>
    }
  </section>
</div>

<ng-template #nameTemplate let-row>
  @if (row.nameKey) {
    {{ row.nameKey | translate }}
  } @else if (row.operation) {
    {{ row.operation | serverTranslate: 'operationName' }}
  }
</ng-template>
<ng-template #sourceTemplate let-row>
  {{ row.sourceKey | translate }}
</ng-template>
<ng-template #actionsTemplate let-row>
  @if (row.canEdit && row.operation) {
    <app-table-actions
      [row]="row.operation"
      (editAction)="openEditModal($event)"
      (deleteAction)="deleteItem($event)"
    />
  }
</ng-template>

<p-dialog
  [resizable]="false"
  [draggable]="false"
  [(visible)]="calendarDialogVisible"
  [modal]="true"
  [header]="'Select date' | translate"
  [style]="{ width: '420px' }"
  [appendTo]="'body'"
  [baseZIndex]="21000"
  styleClass="fdd-dialog fdd-dialog--nested"
>
  @if (calendarFormFields.length) {
    <msf-form-builder
      [fields]="calendarFormFields"
      [(model)]="calendarFormModel"
      flexDirection="column"
    ></msf-form-builder>
  }
  <ng-template pTemplate="footer">
    <div class="fdd-calendar-footer">
      <app-secondary-button
        icon="pi pi-times"
        [title]="'Отменить'"
        (action)="closeCalendarDialog()"
      ></app-secondary-button>
      <app-primary-button
        icon="pi pi-check"
        [title]="'Apply'"
        (action)="applyCalendarSelection()"
      ></app-primary-button>
    </div>
  </ng-template>
</p-dialog>
